import { useEffect } from "react";

export default function useScrollHideHeader(elementIds = []) {
  useEffect(() => {
    let prevScroll = window.scrollY || document.documentElement.scrollTop;
    let curScroll;
    let direction = 0;
    let prevDirection = 0;

    const checkScroll = () => {
      curScroll = window.scrollY || document.documentElement.scrollTop;

      if (curScroll > prevScroll) {
        direction = 2; // down
      } else if (curScroll < prevScroll) {
        direction = 1; // up
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }

      prevScroll = curScroll;
    };

    const toggleHeader = (direction, curScroll) => {
      elementIds.forEach((id) => {
        const header = document.getElementById(id);
        if (!header) return;

        if (direction === 2 && curScroll > 52) {
          header.classList.add("shrink-animation");
          header.classList.remove("expand-animation");
          prevDirection = direction;
        } else if (direction === 1) {
          header.classList.add("expand-animation");
          header.classList.remove("shrink-animation");
          prevDirection = direction;
        }
      });
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, [elementIds]);
}